<div class="pmd-footer">
   <div class="container-fluid p-0">
      <div class="row">
         <div class="col-12 col-md mb-2 mb-md-0">
            <div class="pmd-site-info text-md-right">
               <p class="" tabindex="0" >&copy; {{currentYear}} <strong class="font-heading">PayKanz.</strong> All Rights Reserved <span class="opacity-50 ms-1">v{{appVersion}}</span></p>
            </div>
         </div>
         <div class="col-md-auto col-12">
            <ul style="pointer-events:none ;" class="pmd-footer-nav pmd-footer-nav-divider mb-2 mb-lg-0">
               <li><a href="/terms-conditions" aria-label="Press enter to open terms of use page">Terms of Use</a></li>
               <li><a href="/privacy-policy" aria-label="Press enter to open privacy policy page">Privacy Policy</a></li>
            </ul>
         </div>
      </div>
   </div>
</div>